import $ from 'jquery';
//import utils from '../Libraries/Utils';
//console.log('is touch:', utils.isTouchDevice());

// Focusable elements that are common inside the nav.
let focusableSelector = 'a,button,input,select';

$(window).on('resize', function () {
    let $nav = $('.nav');
    if ($nav.hasClass('nav--visible') || $('.nav-toggle:visible').length < 1) {
        $nav.removeAttr('aria-hidden');
        $nav.find(focusableSelector).removeAttr('tabindex');
    } else {
        $nav.attr('aria-hidden', true);
        $nav.find(focusableSelector).attr('tabindex', -1);
    }
})

$('.nav-toggle').on('click', function (e) {
    e.preventDefault();
    let toggleActiveClass = 'nav-toggle--active';
    let navActiveClass = 'nav--visible';
    let $nav = $('.nav');
    if ($(this).hasClass(toggleActiveClass)) {
        $(this).removeClass(toggleActiveClass);
        $(this).attr('aria-expanded', false);
        $nav.removeClass(navActiveClass);
        $nav.attr('aria-hidden', true);
        $nav.find(focusableSelector).attr('tabindex', -1);
    } else {
        $(this).addClass(toggleActiveClass);
        $(this).attr('aria-expanded', true);
        $nav.addClass(navActiveClass);
        $nav.removeAttr('aria-hidden');
        $nav.find(focusableSelector).removeAttr('tabindex', -1);

        // Focussing the link immediately causes the nav to scroll down while opening, causing a weird jump.
        // To prevent that we delay it by the opening transition time plus a bit.
        window.setTimeout(() => {
            $nav.find(focusableSelector).first().focus();
        }, 350); // transition time + 50ms
    }
});


$('.nav__toggle').on('click', function (e) {
    e.preventDefault();
    $(this).siblings('.nav__list').toggleClass('nav__list--visible');
    $(this).toggleClass('nav__toggle--open');
})
